import { render, staticRenderFns } from "./DotsMenu.vue?vue&type=template&id=5670cd9f&scoped=true"
import script from "./DotsMenu.vue?vue&type=script&lang=js"
export * from "./DotsMenu.vue?vue&type=script&lang=js"
import style0 from "./DotsMenu.vue?vue&type=style&index=0&id=5670cd9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670cd9f",
  null
  
)

export default component.exports